import * as Yup from 'yup'

const StudentPlanFormValidations = () => {
  return Yup.object().shape({
  })
}

export { StudentPlanFormValidations }
